export default "__VITE_ASSET__Di41r$Jb__"